import React from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import subscriptionsApi from '@api/subscription'
import SubscriptionsReportSearch from '@components/subscriptions/dashboard/Search';
import SubscriptionsChart from '@components/subscriptions/dashboard/SubscriptionsChart';
import CountChart from '@components/subscriptions/dashboard/CountChart';
import ReportList from '@components/subscriptions/dashboard/List';
import {SubscriptionStatus} from "../../models/subscription";
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";
import whitListData from '../../hocs/withListData';
import withPaginationComponent from '../../hocs/withPaginationComponent';


function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
    status : SubscriptionStatus.Active
  }
}

function SubscriptionsDashboardPage(props) {
  const { data, isFetched, search} = props;
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <SubscriptionsReportSearch search={search}/>
        </Card>
      </Col>
      <Col span={24}>
        {data.length > 0 && (
          <Row gutter={12}>
            <Col span={12}>
              <SubscriptionsChart data={data}/>
            </Col>
  
            <Col span={12}>
              <CountChart data={data}/>
            </Col>
          </Row>
        )}
        
        <ReportList
          loading={!isFetched}
          data={data}/>
      </Col>
    </Row>
  )
}



export default whitListData(
  withPaginationComponent(SubscriptionsDashboardPage),
  {
    listName: "SubscriptionsList",
    fetchRequest: subscriptionsApi.getStatistics,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);

